import { render, staticRenderFns } from "./uom-prices.vue?vue&type=template&id=03155b92"
import script from "./uom-prices.vue?vue&type=script&lang=js"
export * from "./uom-prices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports